import { render, staticRenderFns } from "./Component.ReportUserDetails.vue?vue&type=template&id=8d49ab82&scoped=true&"
import script from "./Component.ReportUserDetails.vue?vue&type=script&lang=js&"
export * from "./Component.ReportUserDetails.vue?vue&type=script&lang=js&"
import style0 from "./Component.ReportUserDetails.vue?vue&type=style&index=0&id=8d49ab82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d49ab82",
  null
  
)

export default component.exports